
export default {
  routeImporter: {
    loadRouteFile: 'Datei importieren',
    failedToLoadFile: 'Die gewählte Datei konnte nicht geladen werden. Stellen Sie sicher, dass die Datei nicht beschädigt ist und in einem der akzeptierten Formate vorliegt.',
    acceptedImportTypes: 'Akzeptierte Formate',
    dictDefaultMessage: 'Datei mit Route hier ablegen oder hier klicken',
    dictFallbackMessage: 'Browser nicht unterstützt',
    dictFileTooBig: 'Datei zu groß',
    dictInvalidFileType: 'Ungültiges Dateiformat',
    dictCancelUpload: 'Upload abbrechen',
    dictUploadCanceled: 'Upload abgebrochen',
    dictRemoveFile: 'Datei löschen'
  }
}
